<script>
  import { checkbox } from 'vue-strap';
  import 'vue-strap/dist/vue-strap-lang';
  import { datepicker } from 'vue-strap';
  import solicitacaoBolsaServico from '../../servico';

  export default {
    components: { checkbox, datepicker },
    props: {
      solicitacao: {
        type: Object,
        required: true
      },
      edicao: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),

        valorCheck: '0',
        prazoCheck: '0',

        contratosTermoAditivo: [],
      }
    },
    methods: {
      validar(valido) {
        if (!valido) throw new Error("validacao com erro");

        if (this.valorCheck == '0' && this.prazoCheck == '0') {
          this.$swal(
            '',
            'É necessário selecionar pelo menos um tipo(valor, prazo)',
                  'info'
          );

          return false;
        }

        return this.$validator.validateAll();
      },
      carregarContratosTermoAditivo(cpfCnpj) {
        return solicitacaoBolsaServico
          .contratosTermoAditivo(this.solicitacao.idProjeto, cpfCnpj)
          .then(contratosTermoAditivo => {
            this.contratosTermoAditivo = contratosTermoAditivo;
          });
      },
      habilitarValor() {
        const inputValor = document.getElementById("valortermo");
        const selectValor = document.getElementById("tipoValor");


        if (!this.edicao) {
          if (this.valorCheck == '0') {
            inputValor.removeAttribute('disabled');
            selectValor.removeAttribute('disabled');
          } else {
            inputValor.setAttribute('disabled', 'disabled');
            selectValor.setAttribute('disabled', 'disabled');
            this.solicitacao.tipoValor = '';
            this.solicitacao.valorTermo = '';
          }
        } else {
          inputValor.removeAttribute('disabled');
          selectValor.removeAttribute('disabled');
        }
      },
      habilitarPrazo() {
        const inputPrazo = document.getElementById("dias");
        const selectPrazo = document.getElementById("tipoPrazo");

        if (!this.edicao) {
          if (this.prazoCheck == '0') {
            inputPrazo.removeAttribute('disabled');
            selectPrazo.removeAttribute('disabled');
          } else {
            inputPrazo.setAttribute('disabled', 'disabled');
            selectPrazo.setAttribute('disabled', 'disabled');
            this.solicitacao.tipoPrazo = '';
            this.solicitacao.dias = '';
          }
        } else {
          inputPrazo.removeAttribute('disabled');
          selectPrazo.removeAttribute('disabled');
        } 
      },
      calculaDias() {
        if (this.prazoCheck == '0') return;

        var start = this.solicitacao.dataVigenciaInicioTa;
        var end = this.solicitacao.dataVigenciaTerminoTa;


        var diff = moment(start, "DD/MM/YYYY HH:mm:ss").diff(moment(end, "DD/MM/YYYY HH:mm:ss"));
        var dias = moment.duration(diff).asDays();

        if (dias == NaN) return;

        this.solicitacao.dias = Math.abs(dias);
      },
    },
    computed: {
      validarValor() {
        return (this.valorCheck == '1') ? 'required' : '';
      },
      validarPrazo() {
        return (this.prazoCheck == '1') ? 'required' : '';
      },
    },
    mounted() {
      if (this.solicitacao.tipoValor) 
        this.valorCheck = "1";

      if (this.solicitacao.tipoPrazo)
        this.prazoCheck = "1";

      this.carregarContratosTermoAditivo(this.solicitacao.cpfCnpj);
    },
    watch: {
      'solicitacao.dataVigenciaInicioTa': 'calculaDias',
      'solicitacao.dataVigenciaTerminoTa': 'calculaDias',
      'solicitacao.tipoPrazo': 'calculaDias'
    },
  }
</script>

<template>
  <div>

    <div class="row">
      <div class="col-lg-2">
        <div class="form-group required" :class="{'has-error': errors.has('dataTermoAditivoTa')}">
          <label class="control-label">Data termo aditivo</label>

          <datepicker id="dataTermoAditivoTa"
                      v-mascara="'data-mask'"
                      v-model="solicitacao.dataTermoAditivoTa"
                      format="dd/MM/yyyy"
                      placeholder="  /  /     "
                      lang="pt-BR"
                      data-vv-name="dataTermoAditivoTa"
                      data-vv-as="data termo aditivo"
                      v-validate="'required|date_format:DD/MM/YYYY'">
          </datepicker>

          <p class="text-danger" v-show="errors.has('dataTermoAditivoTa')">{{ errors.first('dataTermoAditivoTa') }}</p>
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group required" :class="{'has-error': errors.has('dataVigenciaInicioTa')}">
          <label class="control-label">Vigência inicio</label>

          <datepicker id="dataVigenciaInicioTa"
                      v-mascara="'data-mask'"
                      v-model="solicitacao.dataVigenciaInicioTa"
                      format="dd/MM/yyyy"
                      placeholder="  /  /     "
                      lang="pt-BR"
                      data-vv-name="dataVigenciaInicioTa"
                      data-vv-as="vigência início"
                      v-validate="'required|date_format:DD/MM/YYYY'">
          </datepicker>

          <p class="text-danger" v-show="errors.has('dataVigenciaInicioTa')">{{ errors.first('dataVigenciaInicioTa') }}</p>
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group required" :class="{'has-error': errors.has('dataVigenciaTerminoTa')}">
          <label class="control-label">Vigência término</label>

          <datepicker id="dataVigenciaTerminoTa"
                      v-mascara="'data-mask'"
                      v-model="solicitacao.dataVigenciaTerminoTa"
                      format="dd/MM/yyyy"
                      placeholder="  /  /     "
                      lang="pt-BR"
                      data-vv-name="dataVigenciaTerminoTa"
                      data-vv-as="vigência término"
                      v-validate="'required|date_format:DD/MM/YYYY'">
          </datepicker>

          <p class="text-danger" v-show="errors.has('dataVigenciaTerminoTa')">{{ errors.first('dataVigenciaTerminoTa') }}</p>
        </div>
      </div>

      <div class="col-xs-3">
        <div class="checkbox">
          <checkbox v-model="solicitacao.tipoPlanoTrabalho" value="1" type="success">
            Alteração do plano de trabalho
          </checkbox>
        </div>
      </div>

      <div class="col-xs-3">
        <div class="checkbox">
          <checkbox v-model="solicitacao.tipoTermoContratual" value="1" type="success">
            Alteração de termo contratual
          </checkbox>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-4">
        <div class="checkbox">
          <checkbox v-model="valorCheck" type="success" @checked="habilitarValor" id="checkValor" true-value="1" false-value="0">
            Valor
          </checkbox>
        </div>
      </div>

      <div class="col-xs-4">
        <div class="checkbox">
          <checkbox v-model="prazoCheck" type="success" @checked="habilitarPrazo" id="checkPrazo" true-value="1" false-value="0">
            Prazo
          </checkbox>
        </div>
      </div>

      <div class="col-xs-4">
        Contrato
      </div>
    </div>

    <div class="row">
      <div class="col-xs-2">
        <div class="form-group" :class="{'has-error': errors.has('tipoValor')}">
          <select class="form-control"
                  id="tipoValor"
                  disabled
                  v-validate="validarValor"
                  data-vv-as="tipo valor"
                  data-vv-name="tipoValor"
                  v-model="solicitacao.tipoValor">
            <option value="1">Acréscimo</option>
            <option value="2">Supressão</option>
          </select>

          <p class="text-danger" v-show="errors.has('tipoValor')">{{ errors.first('tipoValor') }}</p>
        </div>
      </div>

      <div class="col-xs-2">
        <div class="form-group" :class="{'has-error': errors.has('valortermo')}">
          <input type="text"
                 class="form-control text-right"
                 id="valortermo"
                 v-model="solicitacao.valortermo"
                 data-vv-name="valortermo"
                 data-vv-as="valor"
                 placeholder="0,00"
                 v-validate="validarValor"
                 disabled
                 v-mascara="'moeda'">

          <p class="text-danger" v-show="errors.has('valortermo')">{{ errors.first('valortermo') }}</p>
        </div>
      </div>

      <div class="col-xs-2">
        <div class="form-group" :class="{'has-error': errors.has('tipoPrazo')}">
          <select class="form-control"
                  id="tipoPrazo"
                  disabled
                  v-validate="validarPrazo"
                  data-vv-as="tipo prazo"
                  data-vv-name="tipoPrazo"
                  v-model="solicitacao.tipoPrazo">
            <option value="1">Acréscimo</option>
            <option value="2">Supressão</option>
          </select>

          <p class="text-danger" v-show="errors.has('tipoPrazo')">{{ errors.first('tipoPrazo') }}</p>
        </div>
      </div>

      <div class="col-xs-2">
        <div class="form-group" :class="{'has-error': errors.has('dias')}">
          <input type="text"
                 class="form-control text-right"
                 id="dias"
                 v-model="solicitacao.dias"
                 data-vv-name="dias"
                 data-vv-as="dias"
                 placeholder="dias"
                 disabled
                 v-validate="validarPrazo"
                 v-mascara="'numero'">

          <p class="text-danger" v-show="errors.has('dias')">{{ errors.first('dias') }}</p>
        </div>
      </div>

      <div class="col-xs-4">
        <div class="form-group required" :class="{'has-error': errors.has('contrato')}">
          <select class="form-control"
                  id="contrato"
                  v-validate="configuracao.obrigatorioContratoTermoAditivo == 1 ? `required` : ''"
                  data-vv-name="contrato"
                  data-vv-as="contrato"
                  v-model="solicitacao.idContratoTermoAditivo">
            <option value="">Selecione...</option>
            <option :value="contratoTermoAditivo.idContrato" v-for="contratoTermoAditivo in contratosTermoAditivo">{{ contratoTermoAditivo.nomeContrato }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('contrato')">{{ errors.first('contrato') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group required" :class="{'has-error': errors.has('descricaoObjetoTa')}">
          <label class="control-label" for="descricaoObjetoTa">Descrição do objeto</label>

          <textarea
            class="form-control"
            id="descricaoObjetoTa"
            v-model="solicitacao.descricaoObjetoTa"
            data-vv-name="descricaoObjetoTa"
            data-vv-as="descrição do objeto"
            v-validate="'required'">
          </textarea>

          <p class="text-danger" v-show="errors.has('descricaoObjetoTa')">{{ errors.first('descricaoObjetoTa') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group" :class="{'has-error': errors.has('observacaoTa')}">
          <label class="control-label" for="observacaoTa">Observação</label>

          <textarea class="form-control"
                    id="observacaoTa"
                    v-model="solicitacao.observacaoTa"
                    data-vv-name="observacaoTa"
                    data-vv-as="observação">
          </textarea>

          <p class="text-danger" v-show="errors.has('observacaoTa')">{{ errors.first('observacaoTa') }}</p>
        </div>
      </div>
    </div>
    
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-bolsa/componentes/compartilhado/FormDadosTermoAditivo.vue